import { Component, OnInit } from '@angular/core';
import { MessService } from '../mess.service';

@Component({
  selector: 'app-mess-header',
  templateUrl: './mess-header.component.html',
  styleUrls: ['./mess-header.component.scss']
})
export class MessHeaderComponent implements OnInit{

  isCollapsed: boolean = false;
  campusName: string | null;
  userName: string | null;

  constructor(private Service: MessService) {
    this.Service.collapsed$.subscribe(data => {
      this.isCollapsed = data;
    });
  }

  ngOnInit(): void {
    this.campusName = localStorage.getItem('campusName');
    this.userName = localStorage.getItem('userName');
  }

  logOut() {
    const logoutPage = localStorage.getItem('logoutPage')
    if (logoutPage) {
      window.location.href = logoutPage;
    }
  }

  toggleCollapse() {
    this.Service.toggleCollapse();
    // const newWidth = this.isCollapsed ? '100%' : '92%';
    // this.Service.updateWidth(newWidth);
  }

}
